import { render } from "./GptAd.vue?vue&type=template&id=72ee2944&scoped=true"
import script from "./GptAd.vue?vue&type=script&lang=js"
export * from "./GptAd.vue?vue&type=script&lang=js"

import "./GptAd.vue?vue&type=style&index=0&id=72ee2944&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72ee2944"

export default script